(function($) {
    $(document).ready(function() {



		if($(window).width() < 600){
			jQuery('.fund-eco-tool .uk-dropdown li a').each(function(){
				var bottom = $(this).attr('uk-tooltip').replace("pos:right", "pos:bottom");
				$(this).attr('uk-tooltip', bottom)
			})
		}else{
			jQuery('.fund-eco-tool .uk-dropdown li a').each(function(){
				var bottom = $(this).attr('uk-tooltip').replace("pos:bottom", "pos:right");
				$(this).attr('uk-tooltip', bottom)
			})
		}


        $(window).resize(function() {
            var windowsize = $(window).width();
              if(windowsize < 600){
                  jQuery('.fund-eco-tool .uk-dropdown li a').each(function(){
                      var bottom = $(this).attr('uk-tooltip').replace("pos:right", "pos:bottom");
                      $(this).attr('uk-tooltip', bottom)
                  })
              }else{
                  jQuery('.fund-eco-tool .uk-dropdown li a').each(function(){
                      var bottom = $(this).attr('uk-tooltip').replace("pos:bottom", "pos:right");
                      $(this).attr('uk-tooltip', bottom)
                  })
              }
          });



        // check the input field on sponsors and send the ajax request
        if ($('.fund-search-field').val()) {

            $('.loader-container').removeClass('hide');
            $('.loader span').attr('uk-spinner', 'ratio: 1.3');
            $('.table-eco-fund tbody tr:not(:first-child)').hide();
            $('#show-all-funds').removeClass('hide');
            var keyword = $('.fund-search-field').val();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'search_fund',
                    keyword: keyword
                },
                success: function(e) {

                    $('.funds').empty().append(e);
                    $('.loader-container').addClass('hide');
                    $('.loader span').removeAttr('uk-spinner');
                    $('.loader span').removeClass('uk-spinner');
                    $('.btn_prev_link').attr('data-keyword', keyword);
                    $('.btn_next_link').attr('data-keyword', keyword);
                    $('.letter-filter').attr('data-keyword', keyword);
                }
            });

            // scroll the element containing the feed data into view
            document.getElementById('show-all-funds').scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center'
            });
        }

        //Load more posts
        $('#load_more').on('click', function(e) {
            e.preventDefault();

            $(this).attr('uk-spinner', 'ratio: 0.7');
            $(this).prop("disabled", true);
            $('#load_more i').hide();

            var page = parseInt($(this).attr('data-paged'));

            var max = parseInt($(this).attr('data-max'));

            var type = $(this).data('type');

            max = max - 1;

            page += 1;

            $(this).attr('data-paged', page);
            
            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'load_more',
                    posts: $(this).data('posts'),
                    type: $(this).data('type'),
                    paged: page,
                },
                success: function(e) {

                    $('#load_more').removeAttr('uk-spinner');
                    $('#load_more').removeClass('uk-spinner');
                    $('#load_more').prop("disabled", false);
                    $('#load_more i').show();
                    $('.posts').append(e);

                    var getUrl = window.location;

                    var baseUrl = getUrl.pathname + "?" + getUrl.search.substr(1);

                    if (page == max) {
                        $('#load_more').parent().hide();
                    }

                    page += 1;

                    max += 1;

                    window.history.pushState('', '', baseUrl + '#page=' + page);
                }
            })
        });

        //categorize blog
        $('.category-dp li a').on('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            $('.category-dp li').removeClass('uk-active');
            $this.parent().addClass('uk-active');
            $this.attr('data-category');
            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'json',
                data: {
                    action: 'categorize_posts',
                    category: $this.attr('data-category')
                },
                success: function(data) {
                    $('.posts').empty().append(data.html);
                    $('.uk-button-categorize span').text($this.text());
                    if (data.maxnum == 1) {
                        $('#load_more').parent().hide();
                    } else {
                        $('#load_more').parent().show();
                        var load_more = $('#load_more').data('posts');
                        load_more['category_name'] = $this.attr('data-category');
                        load_more = JSON.stringify(load_more);
                        $('#load_more').attr('data-posts', load_more);
                        $('#load_more').attr('data-paged', 0);
                        $('#load_more').attr('data-max', data.maxnum);
                    }

                }
            })
        });

        //filter dropdown in fund
        $('.filter-dropdown li a').on('click', function(e) {

            e.preventDefault();

            var $this = $(this);

            var id = $this.data('id');
            //var title = $this.data('title');
            //var info = $this.data('info');
            var field = $this.data('field');
            var values = '';

            //$this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-id', id);
            //$this.closest('.uk-dropdown').parent('.uk-position-relative').find('.info-box-child').remove();
            //$this.closest('.uk-dropdown').parent('.uk-position-relative').prepend('<i data-title="' + title + '" data-info="' + info + '" class="fas fa-info info-box info-box-child uk-margin-small-right uk-margin-small-left uk-dropdown-close"></i>');
            //$this.closest('.uk-dropdown').prev('.uk-button-filter').find('span').text(title);
            //$this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-query', field + '=' + id);
            //$this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-field', field);

            if ($this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-query')) {
                //$this.closest('.uk-dropdown').parent('.uk-position-relative').find('.clear-filter').show();
                $this.closest('.uk-dropdown').parent('.uk-position-relative').addClass('shown');
            }

            $this.closest('.uk-dropdown').parent('.uk-position-relative').parent('.uk-grid').next('.container-clear-filters').show();

            if ($this.attr('data-added') == 'true') {
                $this.attr('data-added', 'false');
                $this.children('span').find('svg').css('display', 'none');
            } else {
                $this.attr('data-added', 'true');
                $this.children('span').find('svg').css('display', 'block');
            }

            $this.closest('.uk-dropdown-nav').children('li').each(function(){
                if ($(this).children('a').attr('data-added') == 'true') {
                    values += $(this).children('a').attr('data-id') + ', ';
                }

            });

            if(values !== ''){
                $('.search-funds').attr(field, values.slice(0,-2));
            }else{
                $('.search-funds').removeAttr(field);
            }
            


            //$('.search-funds').attr(field, id);

            // if ($this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-id')) {
            //     var current_id = $this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-id');
            //     var current_field = $this.closest('.uk-dropdown').prev('.uk-button-filter').attr('data-field');
            //     var values = $('.search-funds').attr(current_field);
            //     values.replace(current_id, id)
            // }

        });

        //clear filter
        $('.clear-filter').on('click', function(e) {

            e.preventDefault();

            var title = $(this).data('title');
            var id = $(this).parent('.uk-position-relative').parent('.uk-grid').attr('id');
            var field = $(this).next('.uk-button-filter').attr('data-field');

            $(this).parent('.uk-position-relative').removeClass('shown');
            $(this).addClass('hide');
            $(this).parent('.uk-position-relative').find('.info-box-child').remove();
            //$(this).parent('.uk-position-relative').prepend('<i data-title="" data-info="" class="fas fa-info info-box info-box-child uk-margin-small-right uk-margin-small-left uk-dropdown-close"></i>');
            $(this).next('button').find('span').text(title);
            $(this).next('button').attr('data-query', '');
            $(this).hide();

            if ($('#' + id + ' div.shown').length == 0) {
                $('#' + id).next('.container-clear-filters').hide();
            }

            $('.search-funds').removeAttr(field);

        });

        //clear all filters
        $('.clear-filters').on('click', function(e) {

            e.preventDefault();

            var fields = '';

            $(this).parent('.container-clear-filters').prev('.uk-grid').find('.uk-position-relative').each(function() {
                //var title = $(this).find('.clear-filter').data('title');
                //$(this).find('button').attr('data-query', '');
                //$(this).find('button span').text(title);
                //$(this).find('.clear-filter').hide();
                //$(this).find('.info-box-child').remove();

                $(this).find('.filter-dropdown li').each(function() {
                    var added = $(this).children('a').data('added');
                    if(added == true){
                        $(this).children('a').attr('data-added','')
                        $(this).children('a').find('svg').css('display', 'none');
                    }
                });

                //$(this).prepend('<i data-title="" data-info="" class="fas fa-info info-box info-box-child uk-margin-small-right uk-margin-small-left uk-dropdown-close"></i>');
                fields += $(this).find('.filter-dropdown li a').attr('data-field') + ' ';
            });

            $('.search-funds').removeAttr(fields);

            $(this).parent('.container-clear-filters').hide();

        });

        //Info Box in Fund eco tool
        $(document).on('click', '.info-box', function(e) {

            if ($(this).data('title')) {
                var title = $(this).data('title');
                var info = $(this).data('info');
                UIkit.modal.dialog('<div class="uk-modal-header"><h6 class="uk-h6 font-bold uk-text-white uk-margin-remove">' + title + '</h6><button class="uk-modal-close-default" type="button" uk-close>Close pop up<span class="info-close"></span></button></div><div class="uk-modal-body">' + info + '</div>');
            }

        });

        if ($('#tool-form').hasClass('page-id-364')) {
            window.print();
        }

        $('#printEvent').on('click', function() {
            window.print();
        })

        var util = UIkit.util;

        var closeAll = util.$('.close-all-filters a');
        var openAll = util.$('.open-all-filters a');

        // close all open items
        util.on(closeAll, 'click', function(e) {
            e.preventDefault();

            var accordionEl = util.$('.fund-eco-tool');

            var openItems = util.$$('.fund-eco-tool > li.uk-open');

            util.each(openItems, function(el) {
                var openIndex = util.index(el);
                UIkit.accordion(accordionEl).toggle(openIndex);
            });

            $('.close-all-filters').hide();
            $('.open-all-filters').show();
        });

        // open all items
        util.on(openAll, 'click', function(e) {

            e.preventDefault();

            var accordionEl = util.$('.fund-eco-tool');

            var allItems = util.$$('.fund-eco-tool > li:not(.uk-open)');

            util.each(allItems, function(el) {
                var openIndex = util.index(el);
                UIkit.accordion(accordionEl).toggle(openIndex);
            });

            $('.open-all-filters').hide();
            $('.close-all-filters').show();
        });

        //show and hide open/close all filter button
        $('.fund-eco-tool > li > a').on('click', function(e) {
            var opened = $(".fund-eco-tool > li.uk-open").length;
            var closed = $(".fund-eco-tool > li").length;

            if (opened < closed - 1) {
                if (opened == closed) {
                    $('.open-all-filters').show();
                    $('.close-all-filters').hide();
                } else if (opened == 1) {
                    $('.open-all-filters').show();
                    $('.close-all-filters').hide();
                }
            } else if (opened == closed - 1) {
                $('.open-all-filters').hide();
                $('.close-all-filters').show();
            }

        });

        //Search Funds Filter
        $(document).on('click', '.search-funds', function(e) {

            e.preventDefault();
            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('#show-all-funds').removeClass('hide');
            $(this).each(function() {

                var query = new Array();
                var core_array = {};
                var sri_strategies_id = new Array();
                var sri_strategies_additional_id = new Array();
                var corporate_activity_id = new Array();

                $.each(this.attributes, function(i, a) {
                    if (a.name.indexOf('data-') == 0) {

                        var title = a.name.replace('data-', '');

                        if (title.indexOf('core-') == 0) {
                            core_array[title.replace('core-', '')] = a.value;
                        }

                        if (title.indexOf('fund-') == 0) {
                            sri_strategies_id.push(a.value);
                        }

                        if (title.indexOf('additional-') == 0) {
                            sri_strategies_additional_id.push(a.value);
                        }

                        if (title.indexOf('management-') == 0) {
                            corporate_activity_id.push(a.value);
                        }


                    }
                })

                query = {
                    'core': core_array,
                    'sri_strategies_id': sri_strategies_id,
                    'sri_strategies_additional_id': sri_strategies_additional_id,
                    'corporate_activity_id': corporate_activity_id,
                };
                
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'funds_filter',
                        funds: query
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);

                        var url_values = $('#funds-inner').data('url-values');

                        $('.loader-container-main').addClass('hide');
                        $('.loader-main span').removeAttr('uk-spinner');
                        $('.loader-main span').removeClass('uk-spinner');
                        $('.print-selected').replaceWith('<a data-link="/print-fund/?fund_id=" data-url-values="'+ url_values +'" class="uk-button-secondary uk-button-small-radius uk-button-submit-filter uk-button print-selected" data-added="false">Print Selected Funds</a>');

                    }
                })

            })


        });

        //Show all Funds
        $(document).on('click', '.show-all', function(e) {

            e.preventDefault();
            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('#show-all-funds').removeClass('hide');
            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'show_all',
                },
                success: function(e) {

                    $('.funds').empty().append(e);

                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');

                    $('.print-selected').replaceWith('<a data-link="/print-fund/?fund_id=" class="uk-button-secondary uk-button-small-radius uk-button-submit-filter uk-button print-selected" data-added="false">Print Selected Funds</a>');

                }
            })


        });

        //previous page
        $(document).on('click', '#btn_prev', function(e) {

            e.preventDefault();
            $('.loader-container').removeClass('hide');
            $('.loader span').attr('uk-spinner', 'ratio: 1.3');
            $('.table-eco-fund tbody tr:not(:first-child)').hide();
            var query = $(this).data('query');
            var page_prev = $('.btn_prev_link').data('page');
            var current = $('.btn_next_link').data('current');
            var first = $(this).data('first');
            var last = $(this).data('last');
            var display = $('.counter-range').text();
            var letter = $(this).data('letter');
            var keyword = $(this).data('keyword');
            var titles = $(this).data('titles');

            if (query) {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'fund_pagination',
                        query: query,
                        page: page_prev,
                        btn: 'prev',
                        letter: letter,
                        keyword: keyword,
                        titles: titles
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);
                        $('html,body').animate({scrollTop: $("#show-all-funds").offset().top},'slow');
                        if (letter) {
                            $('.btn_prev_link').attr('data-letter', letter);
                            $('.btn_next_link').attr('data-letter', letter);

                            $('.alphabet-filter li').each(function() {
                                var active = $(this).children('.letter-filter').data('letter');
                                if(active == letter){
                                    $(this).addClass('active');
                                }
                            });
                        }

                        if (keyword) {
                            $('.btn_prev_link').attr('data-keyword', keyword);
                            $('.btn_next_link').attr('data-keyword', keyword);
                            $('.letter-filter').attr('data-keyword', keyword);
                        }

                        $('.btn_prev_link').attr('data-page', page_prev - 10);

                        if (Math.sign($('.btn_prev_link').attr('data-page')) < 0) {
                            $('.btn_prev_link').prop("disabled", true);
                        } else {
                            $('.btn_prev_link').prop("disabled", false);
                        }

                        if (display) {

                            first -= 10;
                            last -= 10;
                            $('.counter-range').text(first + '-' + last)

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });

                        } else {

                            first -= 10;
                            last -= 10;
                            $('.counter').html('<span class="counter-range">' + first + '-' + last + '</div>')

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });
                        }

                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');

                    }
                })
            } else {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'fund_pagination',
                        page: page_prev,
                        btn: 'prev',
                        letter: letter,
                        keyword: keyword,
                        titles: titles
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);
                        $('html,body').animate({scrollTop: $("#show-all-funds").offset().top},'slow');
                        if (letter) {
                            $('.btn_prev_link').attr('data-letter', letter);
                            $('.btn_next_link').attr('data-letter', letter);

                            $('.alphabet-filter li').each(function() {
                                var active = $(this).children('.letter-filter').data('letter');
                                if(active == letter){
                                    $(this).addClass('active');
                                }
                            });
                        }

                        if (keyword) {
                            $('.btn_prev_link').attr('data-keyword', keyword);
                            $('.btn_next_link').attr('data-keyword', keyword);
                            $('.letter-filter').attr('data-keyword', keyword);
                        }

                        $('.btn_prev_link').attr('data-page', page_prev - 10);

                        if (Math.sign($('.btn_prev_link').attr('data-page')) < 0) {
                            $('.btn_prev_link').prop("disabled", true);
                        } else {
                            $('.btn_prev_link').prop("disabled", false);
                        }


                        if (display) {

                            first -= 10;
                            last -= 10;
                            $('.counter-range').text(first + '-' + last)

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });

                        } else {

                            first -= 10;
                            last -= 10;
                            $('.counter').html('<span class="counter-range">' + first + '-' + last + '</div>')

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });
                        }

                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');
                    }
                })
            }

        });

        //next page
        $(document).on('click', '#btn_next', function(e) {

            e.preventDefault();

            $('.loader-container').removeClass('hide');
            $('.loader span').attr('uk-spinner', 'ratio: 1.3');
            $('.table-eco-fund tbody tr:not(:first-child)').hide();

            var query = $(this).data('query');
            var page = $(this).data('page');
            var current = $(this).data('current');
            var total_pages = $(this).data('total-pages');
            var page_prev = $('.btn_prev_link').data('page');
            var counter = $(this).data('total-funds');
            var display = $('.counter-range').text();
            var letter = $(this).data('letter');
            var keyword = $(this).data('keyword');
            var titles = $(this).data('titles');
            
            if (query) {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'fund_pagination',
                        query: query,
                        page: page,
                        btn: 'next',
                        letter: letter,
                        keyword: keyword,
                        titles: titles
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);
                        $('html,body').animate({scrollTop: $("#show-all-funds").offset().top},'slow');
                        if (letter) {
                            $('.btn_next_link').attr('data-letter', letter);
                            $('.btn_prev_link').attr('data-letter', letter);

                            $('.alphabet-filter li').each(function() {
                                var active = $(this).children('.letter-filter').data('letter');
                                if(active == letter){
                                    $(this).addClass('active');
                                }
                            });
                        }

                        if (keyword) {
                            $('.btn_next_link').attr('data-keyword', keyword);
                            $('.btn_prev_link').attr('data-keyword', keyword);
                            $('.letter-filter').attr('data-keyword', keyword);
                        }

                        $('.btn_next_link').attr('data-page', page + 10);
                        $('.btn_prev_link').attr('data-page', page - 10);
                        $('.btn_next_link').attr('data-current', current + 1);
                        $('.btn_prev_link').prop('disabled', false);

                        if ($('.btn_next_link').attr('data-current') == total_pages) {
                            $('.btn_next_link').prop('disabled', true);
                            $('.counter').text(counter);
                        }

                        if (display) {

                            var first = +display.split('-')[0];
                            var last = +display.split('-')[1];
                            first += 10;
                            last += 10;
                            $('.counter-range').text(first + '-' + last)

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });

                        }

                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');
                    }
                })
            } else {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'fund_pagination',
                        page: page,
                        btn: 'next',
                        letter: letter,
                        keyword: keyword,
                        titles: titles
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);
                        $('html,body').animate({scrollTop: $("#show-all-funds").offset().top},'slow');
                        if (letter) {
                            $('.btn_next_link').attr('data-letter', letter);
                            $('.btn_prev_link').attr('data-letter', letter);

                            $('.alphabet-filter li').each(function() {
                                var active = $(this).children('.letter-filter').data('letter');
                                if(active == letter){
                                    $(this).addClass('active');
                                }
                            });
                        }

                        if (keyword) {
                            $('.btn_next_link').attr('data-keyword', keyword);
                            $('.btn_prev_link').attr('data-keyword', keyword);
                            $('.letter-filter').attr('data-keyword', keyword);
                        }

                        $('.btn_next_link').attr('data-page', page + 10);
                        $('.btn_prev_link').attr('data-page', page - 10);
                        $('.btn_next_link').attr('data-current', current + 1);
                        $('.btn_prev_link').prop('disabled', false);

                        if ($('.btn_next_link').attr('data-current') == total_pages) {
                            $('.btn_next_link').prop('disabled', true)
                            $('.counter').text(counter);
                        }

                        if (display) {

                            var first = +display.split('-')[0];
                            var last = +display.split('-')[1];
                            first += 10;
                            last += 10;
                            $('.counter-range').text(first + '-' + last);

                            $('.btn_prev_link').attr({ 'data-first': first, 'data-last': last });

                        }

                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');
                    }
                })
            }

        });

        //filter by letter
        $(document).on('click', '.letter-filter', function(e) {

            e.preventDefault();
            $('.loader-container').removeClass('hide');
            $('.loader span').attr('uk-spinner', 'ratio: 1.3');
            $('.table-eco-fund tbody tr:not(:first-child)').hide();
            var letter = $(this).data('letter');
            var query = $(this).data('query');
            var keyword = $(this).data('keyword');
            var titles = $(this).data('titles');
            
            if (query) {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'letter_filter',
                        query: query,
                        letter: letter,
                        keyword: keyword,
                        titles: titles
                    },
                    success: function(e) {

                        $('.funds').empty().append(e);
                        $('.btn_prev_link').attr('data-letter', letter);
                        $('.btn_next_link').attr('data-letter', letter);
                        $('.btn_prev_link').attr('data-keyword', keyword);
                        $('.btn_next_link').attr('data-keyword', keyword);
                        $('.letter-filter').attr('data-keyword', keyword);
                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');
                    }
                })
            } else {
                $.ajax({
                    type: 'POST',
                    url: sri_ajax_object.ajax_url,
                    dataType: 'html',
                    data: {
                        action: 'letter_filter',
                        letter: letter,
                        keyword: keyword
                    },
                    success: function(e) {
                        $(this).addClass('uk-active');
                        $('.funds').empty().append(e);
                        $('.btn_prev_link').attr('data-letter', letter);
                        $('.btn_next_link').attr('data-letter', letter);
                        $('.btn_prev_link').attr('data-keyword', keyword);
                        $('.btn_next_link').attr('data-keyword', keyword);
                        $('.letter-filter').attr('data-keyword', keyword);
                        $('.loader-container').addClass('hide');
                        $('.loader span').removeAttr('uk-spinner');
                        $('.loader span').removeClass('uk-spinner');
                    }
                })
            }

        });

        $("#search-fund").submit(function(e) {

            e.preventDefault();
            $('.loader-container').removeClass('hide');
            $('.loader span').attr('uk-spinner', 'ratio: 1.3');
            $('.table-eco-fund tbody tr:not(:first-child)').hide();
            $('#show-all-funds').removeClass('hide');
            var keyword = $('.fund-search-field').val();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'search_fund',
                    keyword: keyword
                },
                success: function(e) {

                    $('.funds').empty().append(e);
                    $('.loader-container').addClass('hide');
                    $('.loader span').removeAttr('uk-spinner');
                    $('.loader span').removeClass('uk-spinner');
                    $('.btn_prev_link').attr('data-keyword', keyword);
                    $('.btn_next_link').attr('data-keyword', keyword);
                    $('.letter-filter').attr('data-keyword', keyword);
                }
            })
        });

        $('p').each(function() {
            var $p = $(this),
                txt = $p.html();
            if (txt == '&nbsp;' || txt == '<strong>&nbsp;</strong>') {
                $p.remove();
            }
        });

        $(function() {
            $("#datepicker").datepicker();
            $('#datepicker').datepicker('setDate', new Date());
        });

        var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        //next day
        $(document).on('click', '#next-day', function(e) {

            e.preventDefault();

            var today = new Date();

            var today_day = String(today.getDate()).padStart(2, '0');

            today = weekday[today.getDay()];

            var date = $('#datepicker').datepicker('getDate');

            date.setDate(date.getDate() + 1);

            var data_day = date.getDate();

            var data_month = date.getMonth() + 1;

            var data_year = date.getFullYear();

            var get_month = month[date.getMonth()];

            var select_day = String(date.getDate()).padStart(2, '0');

            var select = weekday[date.getDay()];

            $('#datepicker').datepicker("setDate", date);

            if (select == today && today_day == select_day) {
                $('.as-of-day').text('Today');
            } else {
                $('.as-of-day').text(select);
            }

            $('.select-date').text(get_month + ' ' + select_day);

            $('.as-of-month').text(get_month);

            var selected = data_day + '-' + data_month + '-' + data_year;

            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('.events > div:not(:first-child)').hide();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'calender_select',
                    date: selected
                },
                success: function(e) {

                    $('.events').empty().append(e);

                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');
                }
            })

        });

        //prev day
        $(document).on('click', '#prev-day', function(e) {

            e.preventDefault();

            var today = new Date();

            var today_day = String(today.getDate()).padStart(2, '0');

            today = weekday[today.getDay()];

            var date = $('#datepicker').datepicker('getDate');

            date.setDate(date.getDate() - 1);

            var data_day = date.getDate();

            var data_month = date.getMonth() + 1;

            var data_year = date.getFullYear();

            var get_month = month[date.getMonth()];

            var select_day = String(date.getDate()).padStart(2, '0');

            var select = weekday[date.getDay()];

            $('#datepicker').datepicker("setDate", date);

            if (select == today && today_day == select_day) {
                $('.as-of-day').text('Today');
            } else {
                $('.as-of-day').text(select);
            }

            $('.select-date').text(get_month + ' ' + select_day);

            $('.as-of-month').text(get_month);

            var selected = data_day + '-' + data_month + '-' + data_year;

            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('.events > div:not(:first-child)').hide();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'calender_select',
                    date: selected
                },
                success: function(e) {

                    $('.events').empty().append(e);

                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');
                }
            })

        });

        //search events
        $("#search-events").submit(function(e) {

            e.preventDefault();

            var title = $('.event-search-field').val();
            var location = $('.event-search-location').val();

            $('.calendar-navigation').hide();
            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('.events > div:not(:first-child)').hide();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'search_event',
                    title: title,
                    location: location,
                },
                success: function(e) {

                    $('.events').empty().append(e);
                    $('.clear-search').show();
                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');
                }
            })

        });

        //on select date
        $(document).on('change', '#datepicker', function(e) {

            e.preventDefault();

            var today = new Date();

            var date = new Date(e.target.value);

            var data_day = date.getDate();

            var data_month = date.getMonth() + 1;

            var data_year = date.getFullYear();

            var get_month = month[date.getMonth()];

            var today_day = String(today.getDate()).padStart(2, '0');

            var select_day = String(date.getDate()).padStart(2, '0');

            today = weekday[today.getDay()];

            select = weekday[date.getDay()];

            if (select == today && today_day == select_day) {
                $('.as-of-day').text('Today');
            } else {
                $('.as-of-day').text(select);
            }

            $('.select-date').text(get_month + ' ' + select_day);

            $('.as-of-month').text(get_month);

            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('.events > div:not(:first-child)').hide();

            var selected = data_day + '-' + data_month + '-' + data_year;

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'calender_select',
                    date: selected
                },
                success: function(e) {

                    $('.events').empty().append(e);

                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');
                }
            })

        });

        //clear search
        $(document).on('click', '.clear-search', function(e) {
            e.preventDefault();

            var today = new Date();

            var data_day = today.getDate();

            var data_month = today.getMonth() + 1;

            var data_year = today.getFullYear();

            var selected = data_day + '-' + data_month + '-' + data_year;

            var get_month = month[today.getMonth()];

            var select_day = String(today.getDate()).padStart(2, '0');

            $('.event-search-field').val('');

            $('.event-search-location').val('');

            $('.as-of-day').text('Today');

            $('.select-date').text(get_month + ' ' + select_day);

            $('.as-of-month').text(get_month);

            $('.loader-container-main').removeClass('hide');
            $('.loader-main span').attr('uk-spinner', 'ratio: 1.3');
            $('.events > div:not(:first-child)').hide();

            $.ajax({
                type: 'POST',
                url: sri_ajax_object.ajax_url,
                dataType: 'html',
                data: {
                    action: 'calender_select',
                    date: selected
                },
                success: function(e) {

                    $('.events').empty().append(e);
                    $('.calendar-navigation').show();
                    $('.clear-search').hide();
                    $('.loader-container-main').addClass('hide');
                    $('.loader-main span').removeAttr('uk-spinner');
                    $('.loader-main span').removeClass('uk-spinner');
                }
            })
        });

        $(document).on('click', '.datepicker-clicker', function(e) {
            e.preventDefault();
            $('#datepicker').datepicker("show");
        });

        var basket_counter = 1;

        //save to basket
        $(document).on('click', '.save-to-basket', function(e) {

            e.preventDefault();

            var id = $(this).data('id');

            $('.print-selected').attr('data-added', 'true');
            if ($(this).attr('data-added') == 'true') {
                var print_field = $(this).data('field');
                $('.print-selected').removeAttr(print_field);
                $(this).attr('data-added', 'false');
                $(this).children('span').css('display', 'none');
            } else {
                if ($(this).data('field')) {
                    $('.print-selected').attr($(this).data('field'), id)
                } else {
                    var basket = basket_counter++;
                    $('.print-selected').attr('data-id_' + basket, id);
                    $(this).attr('data-field', 'data-id_' + basket);
                }
                $(this).attr('data-added', 'true');
                $(this).children('span').css('display', 'block');
            }


        });

        //print selected
        $(document).on('click', '.print-selected', function(e) {

            e.preventDefault();

            if ($(this).attr('data-added') == 'true') {
                var url_values = $(this).data('url-values');
                $(this).each(function() {

                    var fund_ids = '';

                    $.each(this.attributes, function(i, a) {
                        if (a.name.indexOf('data-id') == 0) {

                            var id = a.name.replace('data-', '');
                            if (id.indexOf('id_') == 0) {
                                fund_ids += a.value + ',';
                            }


                        }
                    })

                    var last_comma = fund_ids.slice(-1);

                    if (last_comma == ',') {
                        fund_ids = fund_ids.slice(0, -1);
                    }

                    window.open($(this).data('link') + fund_ids + url_values, '_blank');

                })
            }

        });

        if ($('body').hasClass('home')) {
            var swiper = new Swiper(".mySwiper", {
                direction: "vertical",
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev"
                }
            });
        }
        var swiper = new Swiper(".eventsSwiper", {
            spaceBetween: 30,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 30
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 40
                }
              }
        });
        $('.uk-dropdown-nav li > .uk-dropdown').attr('uk-dropdown', 'pos: right-top; offset: 30');

        $('a.sharethis_link').click(function(e) {
            e.preventDefault();

            $('div[data-network="sharethis"]').click();
        });


    });
}(jQuery));